import React from 'react';
import { string, number, object } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

// Import components
import ItemLink from 'components/views/vod/components/sliders/components/ItemLink';

// Import styles
import {
	Title,
	Subtitle,
	Item
} from 'components/views/vod/components/sliders/styles';

// Import helpers
import { getBannerUrl, getVodUrl } from './helpers';
import { sendGTMEvent } from 'helpers/tracking';

// Import variables
import {
	GTM_TRACKING_EVENTS,
	CLICK_GTM_ACTION,
	FILM_GTM_SEGMENTATION
} from 'helpers/tracking';
const { CLICK_CAROUSEL } = GTM_TRACKING_EVENTS;

export function BannersItem({
	image,
	width,
	height,
	title,
	context,
	subtype,
	uuid
}) {
	const { t } = useTranslation();
	const { pathname } = useLocation();

	// remove domain name from url
	let url = context && context.url_pc ? getBannerUrl(context.url_pc) : '';

	const isBanner = subtype === 'banner';

	const bannerLink = url.replace(/^.*\/\/[^/]+/, '');
	const vodLink = getVodUrl({ subtype, uuid, title });
	const link = isBanner ? bannerLink : vodLink;

	const handleGtmEvent = () =>
		sendGTMEvent({
			event: CLICK_CAROUSEL,
			customEventData: {
				segmentation: FILM_GTM_SEGMENTATION,
				action: CLICK_GTM_ACTION,
				page_url: pathname,
				url: { url: link },
				label: title
			}
		});

	return (
		<ItemLink to={link} isStyledByChildren gtmEvent={handleGtmEvent}>
			<Item image={image} width={width} height={height}>
				<Title>{title}</Title>
				<Subtitle>
					{t('vod_section_category_subtytle')} <span>&#8594;</span>
				</Subtitle>
			</Item>
		</ItemLink>
	);
}

BannersItem.propTypes = {
	image: string.isRequired,
	width: number.isRequired,
	height: number.isRequired,
	title: string.isRequired,
	context: object.isRequired,
	subtype: string.isRequired,
	uuid: string.isRequired
};
